module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/下载引流卡片-二维码图标.c08bb.png";